





















/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IIDTuple,
  IItemForSelection,
  IStatusForSelection,
} from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'JobToggler',

  props: {
    jobsEnabled: {
      type: Boolean,
      required: true,
    },
    showWarningWhenDisabling: {
      type: Boolean,
      default: false,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    statusJobMappings: {
      type: Array as () => IIDTuple[],
      default: null,
    },
    statuses: {
      type: Array as () => IStatusForSelection[],
      default: null,
    },
    jobs: {
      type: Array as () => IItemForSelection[],
      default: null,
    },
  },

  data() {
    return {
      TextAssistant,
      showDropdown: false,
    }
  },

  computed: {
    internalJobsEnabled: {
      get(): Boolean {
        return this.jobsEnabled
      },
      set(value: Boolean) {
        if (this.showWarningWhenDisabling && !value) {
          this.$confirm(
            `By turning off jobs, you are choosing to manually assign ${TextAssistant.itemPluralName(
              this.entityType,
            ).toLowerCase()}. Jobs will be removed from ${TextAssistant.itemPluralName(
              this.entityType,
            ).toLowerCase()} and custom filters. There is no undo. Still continue?`,
            {
              dangerouslyUseHTMLString: true,
              center: true,
              type: 'warning',
              title: 'Turn off jobs',
            },
          ).then(() => {
            this.$emit('update:jobsEnabled', value)
          })
        } else {
          this.$emit('update:jobsEnabled', value)
        }
      },
    },
    hasStatusJobMappings(): boolean {
      return (
        this.statusJobMappings !== null && this.statusJobMappings.length > 0
      )
    },
  },

  methods: {
    getStatusByID(id: number) {
      return this.statuses.find(s => s.id === id)
    },
    getJobByID(id: number) {
      return this.jobs.find(j => j.id === id)
    },
  },
})
